import React from 'react';
import NavigationMenu from './NavigationMenu';
import { useSelector } from 'react-redux';

const Navigation = () => {
    const contentLinks = useSelector((state) => state.navigation.contentLinks);

    return <NavigationMenu links={contentLinks} />;
};

export default Navigation;
